{
  "share": {
    "subject": "Únete al evento «{{title}}» en Agapella",
    "message": "Únete al evento «{{title}}» en Agapella\n{{url}}"
  },
  "types": {
    "retreat": "RETIRO",
    "workshop": "TALLER",
    "ceremony": "CEREMONIA",
    "class": "CLASE",
    "festival": "FESTIVAL",
    "meetup": "ENCUENTRO",
    "practice": "PRÁCTICA"
  },
  "source": {
    "all": "Todos",
    "agape": "Agapē",
    "masters": "Maestros"
  },
  "formatGroup": {
    "live": "En Vivo",
    "events": "Eventos"
  },
  "format": {
    "live_meditation": "Meditación en vivo",
    "guided_practice": "Práctica guiada",
    "breathwork": "Respiración",
    "movement": "Movimiento",
    "somatic": "Práctica somática",
    "sound_bath": "Baño de sonido",
    "mantra": "Mantra y voz",
    "mindfulness": "Sesión de mindfulness",
    "coaching_group": "Sesión de coaching",
    "talk": "Charla / Enseñanza",
    "qa": "Preguntas y respuestas",
    "community_circle": "Círculo comunitario",
    "deep_dive": "Inmersión profunda",
    "morning_ritual": "Ritual matutino",
    "evening_winddown": "Relajación vespertina",
    "workshop": "Taller",
    "masterclass": "Masterclass",
    "intensive": "Intensivo",
    "live_series": "Serie de sesiones en vivo",
    "course_cohort": "Curso / Cohorte",
    "retreat_online": "Retiro (online)",
    "retreat_inperson": "Retiro (presencial)",
    "immersion": "Inmersión / Campamento",
    "challenge": "Desafío",
    "ceremony": "Ceremonia / Círculo",
    "sound_journey": "Viaje sonoro",
    "experience_night": "Noche de experiencia",
    "meetup": "Encuentro (local)",
    "private_1on1": "Sesión 1:1",
    "festival": "Festival / Cumbre",
    "facilitator_training": "Formación de facilitadores",
    "certification": "Programa de certificación"
  },
  "pathGroup": {
    "science": "Ciencia y Psicología",
    "body": "Cuerpo y Somática",
    "spiritual": "Espiritual"
  },
  "path": {
    "mbsr": "Mindfulness basado en evidencia",
    "stress_reset": "Estrés y agotamiento",
    "anxiety": "Regulación de ansiedad",
    "sleep": "Sueño y recuperación",
    "focus": "Enfoque y productividad",
    "emotional_reg": "Regulación emocional",
    "self_compassion": "Autocompasión",
    "cbt": "Prácticas estilo TCC",
    "somatic_psych": "Psicología somática",
    "nervous_system": "Sistema nervioso",
    "trauma_sensitive": "Sensible al trauma",
    "mental_fitness": "Forma mental",
    "somatic_release": "Liberación somática",
    "breath_modern": "Respiración y CO₂",
    "vagus_toning": "Tono vagal",
    "mobility": "Movilidad y estiramiento",
    "yin_relax": "Yin / Relajación profunda",
    "movement_med": "Meditación en movimiento",
    "qigong": "Qigong / Tai Chi",
    "posture": "Postura y presencia",
    "grounding": "Enraizamiento y embodiment",
    "bioenergetic": "Bioenergética / Shake",
    "heart_practice": "Práctica del corazón",
    "awareness": "Conciencia y presencia",
    "intuition": "Intuición y guía interior",
    "energy": "Práctica energética",
    "chakras": "Chakras",
    "sound_vibration": "Sonido y vibración",
    "ritual": "Ritual y simbólico",
    "nature": "Naturaleza / Conexión con la tierra",
    "manifestation": "Manifestación e intención",
    "shadow_work": "Trabajo con la sombra"
  },
  "traditions": {
    "all": "Todas las tradiciones",
    "buddhism": "Budismo",
    "hinduism": "Hinduismo",
    "sufism": "Sufismo",
    "shaivism": "Shivaísmo",
    "yoga": "Yoga",
    "taoism": "Taoísmo",
    "mindfulness": "Mindfulness",
    "tantra": "Tantra"
  },
  "filter": {
    "sessionType": "Tipo de sesión",
    "eventType": "Tipo de evento",
    "pathStyle": "Camino y estilo",
    "clearAll": "Borrar todo",
    "selectedCount": "{{count}} seleccionados"
  }
}
